
export const EXPENSE_ROUTES = [
  {
    path: "expenseForm",
    name: "expenseForm",
    component: () =>
        import(/* webpackChunkName: "expense" */ "@/modules/expense/components/forms/ExpenseForm.vue")
  },
  {
    path: "expenseOverview",
    name: "expenseOverview",
    component: () =>
        import(/* webpackChunkName: "expense" */ "@/modules/expense/layouts/ExpenseOverview.vue")
  }
];
